import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** True when `value` is a UUID — used to tell a real `inventory_items.id` from
 * an AI open-vocab slug (e.g. "cooked-chicken-pieces"). */
export function isUuid(value: string): boolean {
  return UUID_RE.test(value);
}
